import { localizedPath } from "@shared/lib/localized-path";

type AuthRoute = "login" | "register" | "forgot-password";

export function getAuthRouteHref(route: AuthRoute, pathname?: string): string {
  return localizedPath(`/${route}`, pathname);
}
